import { FarmaError } from 'src/integracoes/modelos/erros';
import { getAuth } from "firebase/auth";

export async function obtemFirebaseToken(): Promise<string> {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    const erro = {
      nome: "ERRO-AUTENTICACAO",
      mensagem: "Falha ao obter dados do usuário",
      causa: "Usuário não está autenticado no Firebase"
    }
    throw new FarmaError(erro);
  }

  // idToken válido por 1 hora
  const idToken = await user.getIdToken(false);
  return idToken;
}

